import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { formatCurrency } from 'embed/utils'
import { css } from 'emotion'
import * as React from 'react'

const styles = require('./styles.scss')

export enum SliderThumb {
  ONE = 1,
  TWO = 2,
}

export interface RangeFilter {
  min: number
  max: number
}

export interface SliderProps {
  current: RangeFilter
  initial: RangeFilter
  onChange: (range: RangeFilter) => void
  title: string
  thumbs: SliderThumb
}

export const Slider: React.FunctionComponent<SliderProps> = (props) => {
  const { current, initial, onChange, title, thumbs } = props
  const [selectedRange, setSelectedRange] = React.useState({ min: current.min, max: current.max })
  const [displayRange, setDisplayRange] = React.useState({ width: 100, left: 0 })
  const [leftSlider, setLeftSlider] = React.useState({ value: current.min })
  const [rightSlider, setRightSlider] = React.useState({ value: current.max })

  const handleChange = (e) => {
    const currentValue = Number(e.target.value)
    if (thumbs > 1) {
      if (e.target.id === 'leftSlider' && currentValue < rightSlider.value) {
        setLeftSlider({ value: currentValue })
        setSelectedRange({ ...selectedRange, min: currentValue })
      } else if (e.target.id === 'rightSlider' && currentValue > leftSlider.value) {
        setRightSlider({ value: currentValue })
        setSelectedRange({ ...selectedRange, max: currentValue })
      }
    } else {
      setRightSlider({ value: currentValue })
      setSelectedRange({ ...selectedRange, max: currentValue })
    }
  }

  React.useEffect(() => {
    onChange(selectedRange)
  }, [selectedRange])

  React.useEffect(() => {
    const maxOffset = initial.max - initial.min
    setDisplayRange({
      width: ((rightSlider.value - leftSlider.value) / maxOffset) * 100,
      left: ((leftSlider.value - initial.min) / maxOffset) * 100,
    })
  }, [leftSlider, rightSlider])

  return (
    <ThemeConsumer>
      {({ colorPrimary }) => (
        <div className={styles.badgesListContainer}>
          {title && (
            <div className={css(`display: flex; align-items: baseline; justify-content: space-between;`)}>
              <h4 className={styles.badgesListTitle}>{title}</h4>
              <p>
                ${formatCurrency(selectedRange.min)} - ${formatCurrency(selectedRange.max)}
              </p>
            </div>
          )}
          <div className={styles.badgesContainer}>
            <section>
              <div className={styles.rangeSlider}>
                <span className={styles.fullRange} />
                <span
                  className={classnames(
                    styles.displayRange,
                    css`
                      width: ${displayRange.width}%;
                      left: ${displayRange.left}%;
                      background: ${colorPrimary};
                    `,
                  )}
                />
                {thumbs === 1 && (
                  <input
                    name="rightSlider"
                    value={rightSlider.value}
                    min={initial.min}
                    max={initial.max}
                    step="1"
                    type="range"
                    id="rightSlider"
                    onChange={handleChange}
                    className={classnames(css`
                      ::-webkit-slider-thumb {
                        background: ${colorPrimary};
                      }
                      ::-moz-range-thumb {
                        background: ${colorPrimary};
                      }
                      ::-ms-thumb {
                        background: ${colorPrimary};
                      }
                    `)}
                  />
                )}
                {thumbs === 2 && (
                  <>
                    <input
                      name="leftSlider"
                      value={leftSlider.value}
                      min={initial.min}
                      max={initial.max}
                      step="1"
                      type="range"
                      id="leftSlider"
                      onChange={handleChange}
                      className={classnames(css`
                        ::-webkit-slider-thumb {
                          background: ${colorPrimary};
                        }
                        ::-moz-range-thumb {
                          background: ${colorPrimary};
                        }
                        ::-ms-thumb {
                          background: ${colorPrimary};
                        }
                      `)}
                    />
                    <input
                      name="rightSlider"
                      value={rightSlider.value}
                      min={initial.min}
                      max={initial.max}
                      step="1"
                      type="range"
                      id="rightSlider"
                      onChange={handleChange}
                      className={classnames(css`
                        ::-webkit-slider-thumb {
                          background: ${colorPrimary};
                        }
                        ::-moz-range-thumb {
                          background: ${colorPrimary};
                        }
                        ::-ms-thumb {
                          background: ${colorPrimary};
                        }
                      `)}
                    />
                  </>
                )}
              </div>
            </section>
          </div>
        </div>
      )}
    </ThemeConsumer>
  )
}
